import React, { useEffect, useState } from 'react';
import { Grid, Link, Typography, styled, Container, Box } from '@mui/material';

import { getSiteContactUs } from '@shared/services/services';

import { ID_SITE } from '@shared/conf/env';

import NotFound from '@shared/pages/NotFound';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import EmailIcon from '@mui/icons-material/Email';

import Skeleton from '@mui/material/Skeleton';

import { sxStyle } from './styles';

const BodyContainer = styled('div')(() => ({
  backgroundColor: '#F6F6F6',
}));

export default () => {
  const [siteContactUs, setSiteContactUs] = useState({});
  const [hasErrors, setHasErrors] = useState(false);

  const [loading, setLoading] = useState(false);

  const latitude = siteContactUs.latitude;
  const longitude = siteContactUs.longitude;

  const label = encodeURIComponent(siteContactUs.address);

  const embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3405.0986317803868!2d${longitude}!3d${latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94329878f3e3ce87%3A0x189a8abdd22b9ba7!2s${label}!5e0!3m2!1ses-419!2sar!4v1543587597443`;

  const fetchContactUs = async () => {
    try {
      setLoading(true);
      let result = await getSiteContactUs(ID_SITE);
      setSiteContactUs(result);
      setLoading(false);
    } catch (error) {
      console.error('error', error);
      setHasErrors(true);
    }
  };

  useEffect(() => {
    fetchContactUs();
  }, []);

  if (hasErrors) {
    return (
      <Container>
        <NotFound />
      </Container>
    );
  }

  return (
    <BodyContainer>
      {loading ? (
        <Grid container direction="column" sx={sxStyle.siteContainer}>
          <Grid container direction="column" sx={sxStyle.principalContainer}>
            <Skeleton variant="text" height={50} width="60%" />
            <Skeleton variant="text" height={30} width="80%" />
            <Skeleton variant="text" height={30} width="50%" />

            {/* ICONOS CONTACTO */}
            <Grid
              container
              direction="row"
              sx={sxStyle.iconsContainer}
              spacing={{ xs: 2, md: 3 }}
            >
              {Array.from({ length: 3 }).map((_, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Grid container direction="column" spacing={1}>
                    <Grid item>
                      <Skeleton variant="circular" width={42} height={42} />
                    </Grid>
                    <Grid item>
                      <Skeleton variant="text" height={20} width="70%" />
                    </Grid>
                    <Grid item>
                      <Skeleton variant="text" height={18} width="90%" />
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            {/* AREAS / LISTADO */}
            <Grid
              container
              direction="row"
              spacing={{ xs: 1, md: 2 }}
              sx={sxStyle.infoContainer}
            >
              {Array.from({ length: 3 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Skeleton variant="text" height={40} width="70%" />
                  <Skeleton variant="rectangular" height={100} width="100%" />
                </Grid>
              ))}
            </Grid>

            {/* MAPA */}
            <Grid container direction="column">
              <Skeleton
                variant="text"
                height={40}
                width="30%"
                sx={{ mx: 'auto', mb: 1 }}
              />
              <Skeleton variant="rectangular" width="100%" height={520} />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column" sx={sxStyle.siteContainer}>
          <Grid container direction="column" sx={sxStyle.principalContainer}>
            <Typography component="h4" sx={sxStyle.title}>
              {siteContactUs.title}
            </Typography>

            <Typography component="p" sx={sxStyle.p}>
              Legajo: {siteContactUs.file_number} | {siteContactUs.address}
            </Typography>

            <Grid
              container
              direction="row"
              sx={sxStyle.iconsContainer}
              spacing={{ xs: 1, md: 3 }}
            >
              <Grid item xs={4}>
                <Box sx={sxStyle.contactItem}>
                  <HeadsetMicIcon sx={sxStyle.icon} />

                  <Box>
                    <Typography component="p" sx={sxStyle.p}>
                      Atención telefónica
                    </Typography>

                    <Link
                      href={`tel:${siteContactUs.phone_number}`}
                      sx={sxStyle.link}
                    >
                      {siteContactUs.phone_number}
                    </Link>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={4}>
                <Box sx={sxStyle.contactItem}>
                  <EmailIcon sx={sxStyle.icon} />

                  <Box>
                    <Typography component="p" sx={sxStyle.p}>
                      Correo Electrónico
                    </Typography>

                    <Link
                      href={`mailto:${siteContactUs.email}`}
                      sx={sxStyle.link}
                    >
                      {siteContactUs.email}
                    </Link>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={4}>
                <Box sx={sxStyle.contactItem}>
                  <WhatsAppIcon sx={sxStyle.icon} />

                  <Box>
                    <Typography component="p" sx={sxStyle.p}>
                      WhatsApp
                    </Typography>

                    <Link
                      sx={sxStyle.link}
                      href={`https://wa.me/${siteContactUs.whatsapp?.replace(
                        /[^0-9]/g,
                        ''
                      )}`}
                      target="_blank"
                    >
                      {siteContactUs.whatsapp}
                    </Link>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={{ xs: 1, md: 2 }}
              sx={sxStyle.infoContainer}
              id="contact-grid-info-container"
            >
              {siteContactUs?.areas?.map(area => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  container
                  direction="column"
                  sx={sxStyle.info}
                  key={`${area?.area_types?.name}-${area.id}`}
                >
                  <Typography variant="h4" sx={sxStyle.subTitle}>
                    {area?.area_types?.name}
                  </Typography>

                  <Box component="ul" sx={sxStyle.list}>
                    {area?.area_users?.map(user => (
                      <Box
                        component="li"
                        key={`${area?.area_types?.name}-${user.id}`}
                        sx={sxStyle.listItem}
                      >
                        <Typography sx={sxStyle.p}>
                          {user.name}
                          {user.description && (
                            <Typography
                              component="span"
                              sx={{ ...sxStyle.p, display: 'inline' }}
                            >
                              {' '}
                              ({user.description})
                            </Typography>
                          )}
                        </Typography>

                        <Link href={`mailto:${user.email}`} sx={sxStyle.link}>
                          {user.email}
                        </Link>
                      </Box>
                    ))}
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Grid container direction="column">
              <Typography
                component="h4"
                sx={sxStyle.title}
                style={{ margin: '5px auto' }}
              >
                Dónde estamos
              </Typography>
              <br />
              <iframe
                id="mapa-frame"
                title="Mapa de ubicación"
                width="100%"
                height="520"
                style={{ border: 0, marginTop: '0px' }}
                allowFullScreen={false}
                src={embedUrl}
              ></iframe>
            </Grid>
          </Grid>
        </Grid>
      )}
    </BodyContainer>
  );
};
